import React from "react";
import { CheckOutlined } from "@ant-design/icons";
import { MobileModal } from "./MobileModal";

interface Option {
  label: string;
  value: any;
  disabled?: boolean;
}

interface MobileOptionPickerProps {
  visible: boolean;
  onClose: () => void;
  title: string;
  options: Option[];
  value?: any;
  onChange: (value: any) => void;
  footerText?: string;
}

export const MobileOptionPicker: React.FC<MobileOptionPickerProps> = ({
  visible,
  onClose,
  title,
  options,
  value,
  onChange,
  footerText = "點擊對應顧問以完成選擇",
}) => {
  const handleSelect = (val: any, disabled?: boolean) => {
    if (disabled) return;
    onChange(val);
    onClose();
  };

  return (
    <MobileModal
      visible={visible}
      onClose={onClose}
      title={title}
      footerText={footerText}
    >
      <div
        style={{ display: "flex", flexDirection: "column", paddingTop: "0px" }}
      >
        {options.map((opt) => {
          const isSelected = value === opt.value;
          const isDisabled = opt.disabled || false;
          return (
            <div
              key={String(opt.value)}
              onClick={() => handleSelect(opt.value, isDisabled)}
              style={{
                padding: "12px 16px",
                borderRadius: "10px",
                border: isSelected
                  ? "1px solid #00C8CA"
                  : "1px solid transparent",
                boxShadow: isSelected
                  ? "0px 1px 6px 0px rgba(222,227,234,0.6)"
                  : "none",
                backgroundColor: isSelected ? "#F2FFFF" : isDisabled ? "#f5f5f5" : "transparent",
                color: isDisabled ? "#bfbfbf" : isSelected ? "#00C8CA" : "#1E293B",
                fontWeight: "500",
                fontSize: "14px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                cursor: isDisabled ? "not-allowed" : "pointer",
                transition: "all 0.2s",
                opacity: isDisabled ? 0.6 : 1,
              }}
              // onMouseEnter={(e) => {
              //   if (!isSelected) e.currentTarget.style.backgroundColor = "#fafafa";
              // }}
              // onMouseLeave={(e) => {
              //   if (!isSelected) e.currentTarget.style.backgroundColor = "transparent";
              // }}
            >
              <span style={{ lineHeight: "20px" }}>{opt.label}</span>
              {isSelected && <CheckOutlined />}
            </div>
          );
        })}
      </div>
    </MobileModal>
  );
};
